module.exports = __webpack_public_path__ + "static/img/hahmo-teosten-kaytto.f2b5449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hahmo-teosten-kaytto.png
// module id = 1Dt/
// module chunks = 1